<script>
/* globals window */
import { mapActions } from 'vuex';
import { mapGetters } from 'vuex';
import BaseForm from './base-form';

export default {

    data: function() {
        return {
            ...BaseForm.data(),
            analytics: true
        }
    },

    props: [
        'openModal',
        'closeModal',
        'isModalOpen'
    ],

    mounted() {
        this.boot();
    },

    computed: {
        ...BaseForm.computed
    },

    watch: {
        ...BaseForm.watchers
    },

    methods: {
        ...BaseForm.methods,

        submit(event) {
            this.beforeSubmit().then((token) => {
                this.form.post(event.target.action, {
                        ...this.fields, ...this.persistents,
                        'g-recaptcha-response': token
                    })
                    .then((result) => this.success(result, event))
                    .catch(() => this.failure());
            });
        },
    }
};

</script>



// WEBPACK FOOTER //
// resources/components/forms/trade-partners-form.vue